import a from"./avia.js";var e={name:"widget-rail-info",extends:a};export{e as default};
